module.exports = __webpack_public_path__ + "img/24.b8fd93c5.jpg";